import { motion } from "framer-motion";
import { MaskedLines, Reveal } from "@/components/Reveal";

const PageHero = ({ eyebrow, lines, sub, image, alt }) => (
  <section className="relative overflow-hidden pt-32 sm:pt-40 pb-16 sm:pb-24" data-testid="page-hero">
    <div className="absolute inset-0 hero-glow" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7">
        <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-flame mb-6">{eyebrow}</p>
        <h1 className="font-syne text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] text-white">
          <MaskedLines lines={lines} />
        </h1>
        <Reveal delay={0.45}>
          <p className="mt-6 text-lg text-gray-300 leading-relaxed max-w-xl">{sub}</p>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.2}>
          <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-surface">
            <img src={image} alt={alt} className="w-full h-[300px] lg:h-[440px] object-cover opacity-90" />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" aria-hidden="true" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default PageHero;
